// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles-module__UpdateReportTable___3H9Py{\n    width: calc(100vw - 280px);\n    height: calc(100vh - 128px);\n}", ""]);
// Exports
exports.locals = {
	"UpdateReportTable": "styles-module__UpdateReportTable___3H9Py"
};
module.exports = exports;
